var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 106,
    viewBox: "0 0 150 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 53C59.5078 53 71.25 41.2578 71.25 26.75C71.25 12.2422 59.5078 0.5 45 0.5C30.4922 0.5 18.75 12.2422 18.75 26.75C18.75 41.2578 30.4922 53 45 53ZM63 60.5H61.0547C56.1797 62.8438 50.7656 64.25 45 64.25C39.2344 64.25 33.8438 62.8438 28.9453 60.5H27C12.0938 60.5 0 72.5938 0 87.5V94.25C0 100.461 5.03906 105.5 11.25 105.5H78.75C84.9609 105.5 90 100.461 90 94.25V87.5C90 72.5938 77.9062 60.5 63 60.5ZM112.5 53C124.922 53 135 42.9219 135 30.5C135 18.0781 124.922 8 112.5 8C100.078 8 90 18.0781 90 30.5C90 42.9219 100.078 53 112.5 53ZM123.75 60.5H122.859C119.602 61.625 116.156 62.375 112.5 62.375C108.844 62.375 105.398 61.625 102.141 60.5H101.25C96.4688 60.5 92.0625 61.8828 88.1953 64.1094C93.9141 70.2734 97.5 78.4531 97.5 87.5V96.5C97.5 97.0156 97.3828 97.5078 97.3594 98H138.75C144.961 98 150 92.9609 150 86.75C150 72.2422 138.258 60.5 123.75 60.5Z",
    fill: "#131316",
    fillOpacity: 0.05
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcn);
export default __webpack_public_path__ + "static/media/users-icn.1c1181836b52f949c1de5db01fcd212e.svg";
export { ForwardRef as ReactComponent };